import { Select, Tag } from 'antd';
import React, { FC } from 'react';

export type Props = {
  defaultValue?: string;
  bordered?: boolean;
  size?: 'small' | 'middle' | 'large';
  onChange?: (item: string) => void;
  onBlur?: (e: any) => void;
  value?: string;
  disable?: boolean;
};

const SelectStatus: FC<Props> = (props) => {
  return (
    <Select
      suffixIcon={null}
      size={props.size}
      disabled={props.disable}
      bordered={props.bordered ?? true}
      defaultValue={props.defaultValue}
      value={props.value}
      onBlur={props.onBlur}
      getPopupContainer={(props1) => props1.parentNode}
      onSelect={(item) => props.onChange?.(item)}>
      {['Pending', 'Not Started', 'Ontrack', 'On-hold', 'Offtrack', 'Completed'].map(
        (value: string, index) => (
          <Select.Option key={index} value={value}>
            {value === 'Pending' ? (
              <Tag style={{ height: 25 }} color="blue">
                Pending
              </Tag>
            ) : value === 'Not Started' ? (
              <Tag style={{ height: 25 }} color="">
                Not Started
              </Tag>
            ) : value == 'Ontrack' ? (
              <Tag style={{ height: 25 }} color="yellow">
                Ontrack
              </Tag>
            ) : value == 'On-hold' ? (
              <Tag style={{ height: 25 }} color="cyan">
                On-hold
              </Tag>
            ) : value == 'Offtrack' ? (
              <Tag style={{ height: 25 }} color="red">
                Offtrack
              </Tag>
            ) : (
              <Tag style={{ height: 25 }} color="green">
                Completed
              </Tag>
            )}
          </Select.Option>
        ),
      )}
    </Select>
  );
};

export default SelectStatus;
